import React from 'react';
import PropTypes from 'prop-types';
import useShipment from '@afosto/queries/fulfilment/useShipment';
import useSubscriptions from '@afosto/utils-react/subscription/useSubscriptions';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import MuiLink from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import translations from './translations';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const FULFILMENT_APP_ORIGIN = BASE_URL.replace('{app}', 'fulfilment');

const TransportInfo = ({ transport }) => {
  const subscriptions = useSubscriptions();
  const hasFulfilmentSubscription = subscriptions.some(subscription => subscription.code === 'lcs');
  const { data: inboundShipment } = useShipment(transport?.inbound_shipment_id, {
    enabled: !!transport?.inbound_shipment_id && hasFulfilmentSubscription,
  });
  const { data: outboundShipment } = useShipment(transport?.outbound_shipment_id, {
    enabled: !!transport?.outbound_shipment_id && hasFulfilmentSubscription,
  });

  return (
    <Box pt={0.5}>
      {transport?.reference && (
        <Typography variant="body2">
          <FormattedMessage {...translations.properties.reference} />: {transport.reference}
        </Typography>
      )}
      {hasFulfilmentSubscription && outboundShipment && (
        <MuiLink
          variant="subtitle1"
          href={`${FULFILMENT_APP_ORIGIN}/shipments/${outboundShipment.id}`}
        >
          {outboundShipment.number}
        </MuiLink>
      )}
      <Typography variant="body2">
        <FormattedMessage {...translations.properties.departureAt} />:{' '}
        {formatDateTime(transport?.departure_at)}
      </Typography>
      <Typography variant="body2">
        <FormattedMessage {...translations.properties.arrivalAt} />:{' '}
        {formatDateTime(transport?.arrival_at)}
      </Typography>
      {hasFulfilmentSubscription && inboundShipment && (
        <MuiLink
          variant="subtitle1"
          href={`${FULFILMENT_APP_ORIGIN}/shipments/${inboundShipment.id}`}
        >
          {inboundShipment.number}
        </MuiLink>
      )}
    </Box>
  );
};

TransportInfo.propTypes = {
  transport: PropTypes.object.isRequired,
};

export default TransportInfo;
